import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import profilePlaceholder from '../../../assets/placeholders/profile_placeholder.png'
import { ColorBoxContent, PictureWrapper } from '../../../common/ui/colorBox'
import OrbitSession from '../../../hooks/useCookies'

function CompanyProfileCell({ team }) {
  const [profilePic, setProfilePic] = useState('')
  useEffect(() => {
    const profileImgUrl = OrbitSession.get('profileImg')
    profileImgUrl
      ? setProfilePic(profileImgUrl)
      : setProfilePic(profilePlaceholder)
  }, [])

  return (
    <ColorBoxContent
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '150px'
      }}
    >
      <PictureWrapper
        style={{
          width: '100px',
          height: '100px',
          borderRadius: '100px',
          marginLeft: 16 // To counter internal margin
        }}
        image={profilePic}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Typography variant='h3'>{team}</Typography>
      </Box>
    </ColorBoxContent>
  )
}

CompanyProfileCell.propTypes = {
  team: PropTypes.string
}

export default CompanyProfileCell
